module.exports = __webpack_public_path__ + "static/media/photo-10.f606e7bc.jpg";